export default __webpack_public_path__ + "09e3a154aa0b7592c6e244ce4197576f.svg";